import type { InvoiceStatusLogEntry } from '@/types';
import { formatDateTime } from '@/utils/currency';
import { transitionActionLabels } from './invoiceStatus';

/**
 * Vertikale Status-Timeline aus invoice_status_log — zeigt "wer hat
 * wann was" inkl. Pflichtkommentaren (Korrektur/Ablehnung).
 */
export function InvoiceStatusTimeline({ entries }: { entries: InvoiceStatusLogEntry[] }) {
  if (entries.length === 0) {
    return <p className="text-sm text-gray-500">Kein Statusverlauf vorhanden.</p>;
  }

  return (
    <ol className="relative ml-1 space-y-4 border-l border-gray-200 pl-5">
      {entries.map((entry) => (
        <li key={entry.id} className="relative">
          <span className="absolute -left-[25px] top-1 h-2.5 w-2.5 rounded-full border-2 border-white bg-primary-500" />
          <p className="text-sm font-medium text-gray-900">
            {transitionActionLabels[entry.action] ?? entry.action}
          </p>
          <p className="text-xs text-gray-500">
            {entry.user_name ?? '—'} · {formatDateTime(entry.created_at)}
          </p>
          {entry.comment && (
            <p className="mt-1 rounded-lg bg-gray-50 px-2.5 py-1.5 text-sm text-gray-700">{entry.comment}</p>
          )}
        </li>
      ))}
    </ol>
  );
}